import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, ExternalLink } from 'lucide-react';
import { staffApi } from '../lib/api';
import { useAuth } from '../lib/auth';

export default function FreshaUnmatchedBanner() {
  const { user } = useAuth();
  const [count, setCount] = useState(0);
  const canSee = user?.role === 'operations_manager' || user?.role === 'hr_manager';

  useEffect(() => {
    let cancelled = false;
    if (!canSee) return () => {};
    staffApi.freshaUnmatchedCount().then(r => {
      if (!cancelled) setCount(r.data?.count || 0);
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [canSee]);

  if (!canSee || count === 0) return null;

  return (
    <div className="mb-6 border border-amber-300 bg-amber-50 px-4 py-3 flex items-center justify-between gap-3 flex-wrap" data-testid="fresha-unmatched-banner">
      <div className="flex items-center gap-3">
        <div className="w-8 h-8 bg-amber-100 border border-amber-300 flex items-center justify-center flex-shrink-0">
          <AlertTriangle className="w-4 h-4 text-amber-700" />
        </div>
        <div>
          <p className="text-sm font-semibold text-amber-900">
            {count} {count === 1 ? 'nome Fresha non mappato' : 'nomi Fresha non mappati'} dagli import daily
          </p>
          <p className="text-xs text-amber-800">
            Le metriche di quei dipendenti non vengono importate finché non li associ ad una scheda staff.
          </p>
        </div>
      </div>
      <Link
        to="/settings?tab=fresha-aliases"
        className="text-xs font-semibold px-3 py-1.5 bg-amber-900 text-white hover:bg-amber-950 uppercase tracking-wider"
        data-testid="fresha-unmatched-cta"
      >
        Risolvi ora <ExternalLink className="w-3 h-3 inline ml-1" />
      </Link>
    </div>
  );
}
